import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable()
export class AdminAnalyticsApi {
  protected basePath = `${environment.API_V4}/admin-analytics`;

  constructor(protected http: HttpClient) {}

  public foundationEmails() {
    return this.http.get<(string)[][]>(`${this.basePath}/report/foundation-emails`);
  }

  public foundationSTH() {
    return this.http.get<(string)[][]>(`${this.basePath}/report/foundation-sth`);
  }

  public foundationFulfillmentOptions() {
    return this.http.get<(string)[][]>(`${this.basePath}/report/foundation-fulfillment-options`);
  }
}
